import http from '../const/http-common';

class DimVectorService {
  /**
   * Get paginated list of DIM_Vector records
   * @param {number} page - Page number (default: 1)
   * @param {number} pageSize - Page size (default: 10)
   * @param {number} cubeId - Optional cube ID filter
   * @param {number} dimId - Optional dimension ID filter
   * @returns {Promise} - API response
   */
  async getDimVectors(page = 1, pageSize = 10, cubeId = null, dimId = null) {
    try {
      const params = { page, page_size: pageSize };
      if (cubeId) params.cube_id = cubeId;
      if (dimId) params.dim_id = dimId;
      
      const response = await http.get('/v1/dim-vector/', { params });
      return response.data;
    } catch (error) {
      console.error('Error getting DIM_Vector records:', error);
      throw error;
    }
  }

  /**
   * Get DIM_Vector by ID
   * @param {number} dimVectorId - The DIM_Vector ID
   * @returns {Promise} - API response
   */
  async getDimVector(dimVectorId) {
    try {
      const response = await http.get(`/v1/dim-vector/${dimVectorId}`);
      return response.data;
    } catch (error) {
      console.error('Error getting DIM_Vector:', error);
      throw error;
    }
  }

  /**
   * Create a new DIM_Vector record
   * @param {Object} dimVectorData - The DIM_Vector data
   * @returns {Promise} - API response
   */
  async createDimVector(dimVectorData) {
    try {
      const response = await http.post('/v1/dim-vector/', dimVectorData);
      return response.data;
    } catch (error) {
      console.error('Error creating DIM_Vector:', error);
      throw error;
    }
  }

  /**
   * Update a DIM_Vector record
   * @param {number} dimVectorId - The DIM_Vector ID
   * @param {Object} dimVectorData - The updated DIM_Vector data
   * @returns {Promise} - API response
   */
  async updateDimVector(dimVectorId, dimVectorData) {
    try {
      const response = await http.put(`/v1/dim-vector/${dimVectorId}`, dimVectorData);
      return response.data;
    } catch (error) {
      console.error('Error updating DIM_Vector:', error);
      throw error;
    }
  }

  /**
   * Delete a DIM_Vector record
   * @param {number} dimVectorId - The DIM_Vector ID
   * @returns {Promise} - API response
   */
  async deleteDimVector(dimVectorId) {
    try {
      const response = await http.delete(`/v1/dim-vector/${dimVectorId}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting DIM_Vector:', error);
      throw error;
    }
  }

  /**
   * Get members for a specific dimension
   * @param {number} dimId - The dimension ID
   * @returns {Promise} - API response
   */
  async getMembersByDimension(dimId) {
    try {
      const response = await http.get(`/v1/dim-vector/members/${dimId}`);
      return response.data;
    } catch (error) {
      console.error('Error getting members by dimension:', error);
      throw error;
    }
  }
}

export default new DimVectorService();
